@if (!loading) {
  <div>
    @if (notes.length > 0) {
      <ul class="list-unstyled">
        @for (note of notes; track note) {
          <li>
            <app-note [note]="note" />
          </li>
        }
      </ul>
    } @else {
      @if (noNotesMessage) {
        <p>{{ noNotesMessage }}</p>
      }
      @if (!noNotesMessage) {
        <app-blank-value-dash />
      }
    }
    @if (allowAdd) {
      <app-notes-for-model-add
        [model]="model"
        [modelType]="modelType"
        [minimizeControls] = "minimizeControls"
        (noteAdded)="onNoteAdded($event)"
        />
    }
  </div>
} @else {
  <mat-spinner />
}
